import React from 'react';
import debounce from 'debounce';
export var WindowWidth;
(function (WindowWidth) {
    WindowWidth[WindowWidth["XSmall"] = 0] = "XSmall";
    WindowWidth[WindowWidth["Small"] = 1] = "Small";
    WindowWidth[WindowWidth["Medium"] = 2] = "Medium";
    WindowWidth[WindowWidth["Large"] = 3] = "Large";
    WindowWidth[WindowWidth["XLarge"] = 4] = "XLarge";
    WindowWidth[WindowWidth["Giant"] = 5] = "Giant";
})(WindowWidth || (WindowWidth = {}));
export const useWindowWidth = () => {
    const [windowWidth, setWindowWidth] = React.useState();
    const resizeHandler = debounce(() => {
        switch (true) {
            case window.innerWidth >= 1600:
                setWindowWidth(WindowWidth.Giant);
                break;
            case window.innerWidth >= 1450:
                setWindowWidth(WindowWidth.XLarge);
                break;
            case window.innerWidth >= 1200:
                setWindowWidth(WindowWidth.Large);
                break;
            case window.innerWidth >= 992:
                setWindowWidth(WindowWidth.Medium);
                break;
            case window.innerWidth >= 768:
                setWindowWidth(WindowWidth.Small);
                break;
            default:
                setWindowWidth(WindowWidth.XSmall);
                break;
        }
    });
    React.useEffect(() => {
        resizeHandler();
        window.addEventListener('resize', resizeHandler);
        return () => window.removeEventListener('resize', resizeHandler);
    });
    return windowWidth;
};
export default useWindowWidth;
//# sourceMappingURL=useWindowWidth.js.map